module.exports = __webpack_public_path__ + "static/bscs_logo-4764abf3ed875294200baf166ee88a47.svg";